import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { serviceTypeInterface } from 'src/app/util/interfaces/requestClassification';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ClassificationService {
	private getClassificationServiceTypeURL = environment.baseApiUrl + 'tool/serviceTypes';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getClassificationServiceType(): Observable<serviceTypeInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getClassificationServiceTypeURL, { headers: headers });
	}

	// getClassificationServiceType(): Observable<string[]> {
	//   let servicetypes = ["Problem","Incident","Change","Query","Complaint","Service Request"];
	//   return of(servicetypes);
	// }
}
